import { createSlice } from "@reduxjs/toolkit";
import { replaceDomainWithLocalhost } from "src/helpers/generate-local-prod-url";
import axios from "src/utils/axios";

interface ILink {
  type: "magicLink" | "normalLink";
  link: string;
}

interface ILinkPayload {
  openModal?: boolean;
  loading?: boolean;
  link?: ILink[];
  expiry?: number;
}

interface IRoot {
  keyShorts: string;
  magicLink?: ILinkPayload;
}

const initialState: IRoot = {
    keyShorts: "",
  magicLink: {
    openModal: false,
    loading: false,
    link: [],
    expiry: 15,
  },
};

const slice = createSlice({
    name: "keyshortcuts",
    initialState,
    reducers: {
        setKeyShorts(state, action) {
            state.keyShorts = action.payload;
        },
      magicLink(state, action) {
        state.magicLink[action.payload.key] = action.payload.value;
      },
      resetMagicLink(state) {
        state.magicLink = initialState.magicLink;
      },
      addLink(state, action) {
        state.magicLink.link = action.payload;
      }
    },
});

export const KeyShortcutsAction = slice.actions;

// generate event magic link
export const generateMagicLink = (id, expiry, enqueueSnackbar, normalLink) => async (dispatch) => {
  try {
    dispatch(slice.actions.magicLink({
      key: "loading",
      value: true
    }));
    const response = await axios.put(
      `${process.env.REACT_APP_API_URL}/events/api/v1/events/generate-link/${id}`, { expiry }, {
      headers: {
        "contextId": id
      },
    });
    if (!response?.data?.status) {
      throw new Error(response?.data?.message || "Unable to generate event link");
    }
    if (response?.data?.status) {
      const links = [{
        type: 'magicLink',
        link: replaceDomainWithLocalhost(response?.data?.data?.inviteLink)
      }, {
        type: 'normalLink',
        link: replaceDomainWithLocalhost(normalLink)
      }];
      dispatch(slice.actions.addLink(links));
    }
  } catch (error) {
    const links = [{
      type: 'normalLink',
      link: replaceDomainWithLocalhost(normalLink)
    }];
    dispatch(slice.actions.addLink(links));
    enqueueSnackbar(
      error?.message || error || "Unable to generate event link", {
      variant: "error",
      preventDuplicate: true,
      autoHideDuration: 5000,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "right",
      },
    }
    );
  } finally {
    dispatch(slice.actions.magicLink({
      key: "loading",
      value: false
    }));
    dispatch(slice.actions.magicLink({
      key: "openModal",
      value: true
    }));
  }
};


export const reducer = slice.reducer;
export default slice;
